import { FieldValues, UseFormGetValues, Validate } from "react-hook-form";
import { IValidation, IArrayValidation } from "@generation/core";
import { AbstractCrossFieldValidation } from "./AbstractCrossFieldValidation";

export const mapValidationsToRecord = (
  basePath: string,
  validations?: IValidation[] | IArrayValidation[],
  getValues?: UseFormGetValues<FieldValues>
): Record<string, Validate<unknown, unknown>> => {
  if (!validations || validations.length === 0) {
    return {};
  }

  return {
    ...validations
      .map((item) => {
        if (item instanceof AbstractCrossFieldValidation && getValues) {
          item.setGetValues(getValues);
          item.setBasePath(basePath);
        }

        return {
          [item.key]: item.validate
        };
      })
      .reduce((obj, item) => ({
        ...obj,
        ...item
      }))
  };
};

export type CustomErrorMessage = (label: string) => string;
